import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const promotedTagsQuery = gql`
  query PerksSearchPromotedTags {
    perksSearchPromotedTags {
      name
      tagid
      tag
      path
    }
  }
`

export const promotedTagsQueryKey = getQueryNames(promotedTagsQuery)[0]

export default promotedTagsQuery
